<template>
    <div class="editbooking">
        <Booking></Booking>
    </div>
</template>

<style scoped>
</style>


<script>
    import Booking from '@/components/editbooking_component.vue';
    export default {
        name: 'editbooking',
        data() {
            return {
                //'check': this.Constants.STATUS_CONFIRMED
            }
        },
        components: {
            Booking
        }
    }
</script>
